import React, { FC, useMemo } from 'react'
import styles from './Accordion.module.scss'
import Accordion, { AccordionItemType } from './Accordion'
import ExpandArrowIcon from 'svg/SA/expand-more-small.svg'
import classNames from 'classnames'
import useQA from 'hooks/useQA'

export type TwoColumnsAccordionContentObject = {
  title: string
  text: string // only use trust hardcoded values
}

type TwoColumnsAccordionProps = {
  content: ReadonlyArray<TwoColumnsAccordionContentObject>
  customTwoColumnsAccordionStyles?: string
  title: string
}

const TwoColumnsAccordion: FC<TwoColumnsAccordionProps> = ({
  content,
  customTwoColumnsAccordionStyles,
  title,
}) => {
  const half = Math.ceil(content.length / 2)
  const { testId } = useQA()
  const [faqItemsLeft, faqItemsRight] = useMemo((): [AccordionItemType[], AccordionItemType[]] => {
    const left = content.slice(0, half).map(({ title, text }) => ({
      title,
      content: (
        <p
          className={styles.twoColumnsAccordionContentText}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      ),
    }))
    const right = content.slice(half).map(({ title, text }) => ({
      title,
      content: (
        <p
          className={styles.twoColumnsAccordionContentText}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      ),
    }))

    return [left, right]
  }, [content, half])

  return (
    <div className={classNames(styles.twoColumnsSectionWrapper, customTwoColumnsAccordionStyles)}>
      <div className={styles.twoColumnsSectionContainer} {...testId('accordion-container')}>
        <h4>{title}</h4>
        <div className={styles.twoColumnsGrid} data-style='two-columns-grid'>
          {[faqItemsLeft, faqItemsRight].map((items, index) => (
            <div
              key={index}
              className={index === 0 ? styles.twoColumnsGridLeft : styles.twoColumnsGridRight}
              data-style={index === 0 ? 'two-columns-grid-left' : 'two-columns-grid-right'}
            >
              <Accordion
                items={items}
                headerCustomStyle={styles.accordionHeaderCustomStyle}
                itemCustomStyle={styles.accordionItemCustomStyle}
                CustomIcon={<ExpandArrowIcon className={styles.accordionIconCustomStyle} />}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TwoColumnsAccordion
